import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login } from "../common/api";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const navigate = useNavigate();
  const { login: setAuth } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function handleLogin() {
    setError(null);
    if (!email || !password) return setError("Please enter your email and password");

    setLoading(true);
    try {
      const { token } = await login(email, password);
      setAuth(token);
      navigate("/");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-[420px]">

        {/* Logo */}
        <div
          className="text-center mb-8 cursor-pointer"
          onClick={() => navigate("/")}
        >
          <span className="text-[28px] font-bold text-black">ODK</span>
        </div>

        <div className="bg-white rounded-[24px] shadow-sm border border-gray-100 p-8">
          <h1 className="text-[22px] font-bold text-gray-900 mb-1">Sign In</h1>
          <p className="text-[14px] text-gray-400 mb-6">Welcome back! Please sign in to continue.</p>

          <div className="flex flex-col gap-4">
            <Field label="Email">
              <input
                type="email"
                value={email}
                placeholder="example@email.com"
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                className={inputCls}
                autoFocus
              />
            </Field>

            <Field label="Password">
              <input
                type="password"
                value={password}
                placeholder="Enter your password"
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                className={inputCls}
              />
            </Field>

            {error && <p className="text-[13px] text-red-400">{error}</p>}

            <button
              onClick={handleLogin}
              disabled={loading}
              className="w-full py-3 rounded-[12px] bg-[#E8876A] text-white font-semibold text-[15px] hover:bg-[#D96F52] transition-colors disabled:opacity-50 mt-1"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </div>

          <p className="text-center text-[13px] text-gray-400 mt-6">
            Don't have an account?{" "}
            <Link to="/signup" className="text-[#E8876A] font-semibold hover:underline">
              Sign Up
            </Link>
          </p>
        </div>

      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-[13px] font-medium text-gray-600">{label}</label>
      {children}
    </div>
  );
}

const inputCls = "px-4 py-2.5 rounded-[10px] border border-gray-200 text-[14px] text-gray-800 bg-white outline-none focus:border-[#E8876A] focus:ring-2 focus:ring-[#E8876A]/20 w-full transition-all";